export const INCIDENT_REPORT_STATUS_REPORTED = 'REPORTED'
export const INCIDENT_REPORT_STATUS_VALIDATED = 'VALIDATED'
export const INCIDENT_REPORT_STATUS_DISCARDED = 'DISCARDED'
export const INCIDENT_REPORT_STATUS_RESOLVED = 'RESOLVED'

export const INCIDENT_REPORT_CATEGORY_NFC_READER = 'NFC_READER'
export const INCIDENT_REPORT_CATEGORY_LOCKING_SYSTEM = 'LOCKING_SYSTEM'
export const INCIDENT_REPORT_CATEGORY_CONNECTED_DEVICE = 'CONNECTED_DEVICE'
export const INCIDENT_REPORT_CATEGORY_BODYWORK = 'BODYWORK'
export const INCIDENT_REPORT_CATEGORY_TIRE = 'TIRE'
export const INCIDENT_REPORT_CATEGORY_WINDSHIELD = 'WINDSHIELD'
export const INCIDENT_REPORT_CATEGORY_MECHANICAL = 'MECHANICAL'
export const INCIDENT_REPORT_CATEGORY_12V_BATTERY = 'BATTERY_12V'

export const EMBEDDED_EQUIPMENT_INCIDENT_REPORT_CATEGORIES = [
  INCIDENT_REPORT_CATEGORY_NFC_READER,
  INCIDENT_REPORT_CATEGORY_LOCKING_SYSTEM,
  INCIDENT_REPORT_CATEGORY_CONNECTED_DEVICE,
]

export const VEHICLE_INCIDENT_REPORT_CATEGORIES = [
  INCIDENT_REPORT_CATEGORY_BODYWORK,
  INCIDENT_REPORT_CATEGORY_TIRE,
  INCIDENT_REPORT_CATEGORY_WINDSHIELD,
  INCIDENT_REPORT_CATEGORY_MECHANICAL,
]

export const BACKEND_MANAGED_INCIDENT_REPORT_CATEGORIES = [INCIDENT_REPORT_CATEGORY_12V_BATTERY]

export const isIncidentReportCategoryAllowedForVehicle = (category, vehicle = {}) =>
  category !== INCIDENT_REPORT_CATEGORY_NFC_READER || Boolean(vehicle?.nfc_access_supported)

export const getIncidentReportCategoryGroupedChoices = ({
  nfcAccessSupported = false,
  includeBackendManaged = true,
} = {}) => [
  {
    id: '__group_embedded_equipment',
    disabled: true,
  },
  ...EMBEDDED_EQUIPMENT_INCIDENT_REPORT_CATEGORIES.filter((categoryId) =>
    isIncidentReportCategoryAllowedForVehicle(categoryId, { nfc_access_supported: nfcAccessSupported }),
  ).map((id) => ({ id })),
  { id: '__group_vehicle', disabled: true },
  ...VEHICLE_INCIDENT_REPORT_CATEGORIES.map((id) => ({ id })),
  ...(includeBackendManaged ? BACKEND_MANAGED_INCIDENT_REPORT_CATEGORIES.map((id) => ({ id })) : []),
]

export const INCIDENT_REPORT_SEVERITY_LOW = 'LOW'
export const INCIDENT_REPORT_SEVERITY_MEDIUM = 'MEDIUM'
export const INCIDENT_REPORT_SEVERITY_HIGH = 'HIGH'
export const INCIDENT_REPORT_SEVERITY_CRITICAL = 'CRITICAL'

export const INCIDENT_REPORT_OWNERSHIP_MYMOVE = 'MYMOVE'
export const INCIDENT_REPORT_OWNERSHIP_FLEET_MANAGER = 'FLEET_MANAGER'
export const INCIDENT_REPORT_OWNERSHIP_LEASING_COMPANY = 'LEASING_COMPANY'

export const INCIDENT_REPORT_ACTION_CONFIRM = 'CONFIRM'
export const INCIDENT_REPORT_ACTION_REJECT = 'REJECT'
export const INCIDENT_REPORT_ACTION_RESOLVE = 'RESOLVE'
export const INCIDENT_REPORT_ACTION_ASSIGN_OWNERSHIP = 'ASSIGN_OWNERSHIP'
export const INCIDENT_REPORT_ACTION_UPDATE_SEVERITY = 'UPDATE_SEVERITY'

export const INCIDENT_REPORT_REJECTION_REASON_DUPLICATE = 'DUPLICATE'
export const INCIDENT_REPORT_REJECTION_REASON_KNOWN_ISSUE = 'KNOWN_ISSUE'
export const INCIDENT_REPORT_REJECTION_REASON_INCORRECT_REPORT = 'INCORRECT_REPORT'
export const INCIDENT_REPORT_REJECTION_REASON_INSUFFICIENT_INFORMATION = 'INSUFFICIENT_INFORMATION'
export const INCIDENT_REPORT_REJECTION_REASON_OTHER = 'OTHER'

export const INCIDENT_REPORT_REJECTION_REASONS = {
  [INCIDENT_REPORT_REJECTION_REASON_DUPLICATE]: 'resources.incident-reports.enums.rejectionReason.values.duplicate',
  [INCIDENT_REPORT_REJECTION_REASON_KNOWN_ISSUE]: 'resources.incident-reports.enums.rejectionReason.values.knownIssue',
  [INCIDENT_REPORT_REJECTION_REASON_INCORRECT_REPORT]:
    'resources.incident-reports.enums.rejectionReason.values.incorrectReport',
  [INCIDENT_REPORT_REJECTION_REASON_INSUFFICIENT_INFORMATION]:
    'resources.incident-reports.enums.rejectionReason.values.insufficientInformation',
  [INCIDENT_REPORT_REJECTION_REASON_OTHER]: 'resources.incident-reports.enums.rejectionReason.values.other',
}
